(() => {
  const PRODUCT_HANDLES = [
    'play-et-sens-sensory-clay',
    'play-et-sens-sensory-clay-1',
    'play-et-sens-sensory-clay-2'
  ];

  const productCache = {};
  let hasUserChangedSelector = false;

  function normalizeVariantId(value) {
    const match = String(value || '').match(/(\d+)$/);
    return match ? String(match[1]) : '';
  }

  async function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const data = await res.json();
      productCache[handle] = data;
      return data;
    } catch (e) {
      console.warn('AMP image sync: failed to fetch product', handle, e);
      return null;
    }
  }

  async function findVariantAcrossProducts(variantId) {
    for (const handle of PRODUCT_HANDLES) {
      const product = await fetchProduct(handle);
      if (!product?.variants?.length) continue;

      const variant = product.variants.find((v) => String(v.id) === String(variantId));
      if (variant) {
        return { product, variant, handle };
      }
    }
    return null;
  }

  function getVariantImage(variant, product, selectedText) {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (variant?.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    if (variant?.image?.src) return variant.image.src;

    if (Array.isArray(product?.images) && product.images.length) {
      const needle = String(selectedText || '').toLowerCase();
      const matched = product.images.find((src) => src.toLowerCase().includes(needle));
      return matched || product.images[0];
    }

    return null;
  }

  function updateMainProductImage(newSrc, altText = '') {
    if (!newSrc) return;

    const selectors = [
      '.product__media img',
      '.product-media-container img',
      'media-gallery img',
      '.product__modal-opener img',
      '.slider__slide img'
    ];

    document.querySelectorAll(selectors.join(', ')).forEach((img) => {
      img.src = newSrc;
      img.removeAttribute('srcset');
      if (altText) img.alt = altText;
    });
  }

  async function syncOneSelect(selectEl) {
    if (!selectEl || !hasUserChangedSelector) return;

    const wrapper = selectEl.closest('.amp-bundles__mix-and-match-bundles__product-wrapper');
    if (!wrapper) return;

    const imgEl = wrapper.querySelector('.amp-bundles__product-tile__image');
    if (!imgEl) return;

    const variantId = normalizeVariantId(selectEl.value);
    const selectedText = selectEl.options?.[selectEl.selectedIndex]?.text?.trim() || '';
    if (!variantId) return;

    const found = await findVariantAcrossProducts(variantId);
    if (!found) return;

    const { product, variant } = found;
    const newSrc = getVariantImage(variant, product, selectedText);
    if (!newSrc) return;

    imgEl.src = newSrc;
    imgEl.removeAttribute('srcset');
    imgEl.alt = selectedText || imgEl.alt || 'Selected bundle item';

    updateMainProductImage(newSrc, selectedText);
  }

  document.addEventListener('change', (event) => {
    const selectEl = event.target.closest('.amp-bundles__select__field');
    if (!selectEl) return;

    hasUserChangedSelector = true;
    syncOneSelect(selectEl);
  }, true);

  document.addEventListener('input', (event) => {
    const selectEl = event.target.closest('.amp-bundles__select__field');
    if (!selectEl) return;

    hasUserChangedSelector = true;
    syncOneSelect(selectEl);
  }, true);
})();